import * as Yup from 'yup';

const AddTaskSchema = Yup.object().shape({
  title: Yup.string().trim().min(2, 'Please enter at least 2 characters').required('Task Name is required'),
  plannedHours: Yup.number()
    .min(0, 'Please enter valid Hours')
    .typeError('Planned Hours must be a number')
    .required('Planned Hours is required'),
  project: Yup.object()
    .nullable()
    .shape({
      id: Yup.number().required('Project is required'),
    })
    .required('Project is required'),
  section: Yup.object()
    .nullable()
    .shape({
      id: Yup.number().required('Section is required'),
    })
    .required('Section is required'),
  taskType: Yup.string().nullable().required('Task Type is required'),
  issueType: Yup.string().when('taskType', {
    is: 'Issue',
    then: Yup.string().required('Issue Priority is required').oneOf(['High', 'Medium', 'Low']),
  }),
  parentTaskId: Yup.number().when('taskType', {
    is: 'Issue',
    then: Yup.number().required('Parent Task is required'),
  }),
  startDate: Yup.date().required('Start Date is required').typeError('Enter valid start date'),
  endDate: Yup.date()
    .required('End Date is required')
    .min(Yup.ref('startDate'), 'End Date cannot be before Start Date')
    .typeError('Enter valid end date'),
});

export default AddTaskSchema;
